<template>
  <div>
  <section>
    <div class="left">
      <detail-entity-info
          :entity="entity"
          :omit-default="['id_remote']"
      >
      </detail-entity-info>
    </div>
  <div class="right">
    <div class="field_left">
      <text-input id="thematicGroupname"
                  :required="true"
                  v-model="entity.name"
                  :disabled="disabled"
                  ref="nameref"
      >
        <translate class="translate">Název</translate>

      </text-input>
      <checkbox-input
          id="thematicGroupDeviceVisibility"
          v-model="entity.device_visibility"
          ref="devicevisibilityref"
          :disabled="disabled"
      >
        <translate class="translate">Viditelné na zařízeních</translate>
      </checkbox-input>
    </div>
  </div>
  </section>
    <section>
      <div class="left">
        <h2 v-translate>Překlady názvu</h2>
        <div class="left">
        </div>
      </div>
      <div class="right">
        <div :class="[index % 2 ? 'field_right' : 'field_left']" v-for="(language, key, index) in languages">
          <text-input :id="'tranlation_'+key"
                      :required="true"
                      :disabled="disabled"
                      v-model="entity.translations[key]"
                      :ref="'tranlation_'+key+'_ref'"
          >
            {{language}}
          </text-input>
        </div>
      </div>
    </section>
    <section>
      <div class="left">
        <h2 v-translate>Kanály</h2>
        <div class="left">
        </div>
      </div>
      <div class="right">
        <SortableCheckboxList
            v-if="channels.length > 0"
            :items="channels"
            :is-channel-list="true"
            v-model="entity.id_channels"
            :disabled="disabled"
            :allow-sorting="!entity.system || !!entity.id_operator"
            :allow-selecting="entity.custom_group"
            name="channels"
        >
        </SortableCheckboxList>
      </div>
    </section>
  </div>
</template>

<script>
import Message from "../../../mixins/message";
import DetailEntityInfo from "../../../common/DetailEntityInfo.vue";
import SortableCheckboxList from "../../../common/SortableCheckboxList.vue";

export default {
  name: "ThematicGroupBasicForm",
  components: {DetailEntityInfo, SortableCheckboxList},
  mixins: [Message],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  created(ChannelService) {
    this.channelService = ChannelService;
    this.reloadChannels();
  },
  data(){
    return {
      selectedLanguage: null,
      channels: [],
      languages: {
        'ces': this.$gettext('Čeština'),
        'eng': this.$gettext('Angličtina'),
        'deu': this.$gettext('Němčina'),
        'slk': this.$gettext('Slovenština'),
        'hun': this.$gettext('Maďarština')
      },
    }
  },
  computed: {
    disabled(){
      return !this.isEditable || !this.$_updateActionAllowed;
    },
  },
  methods:{
    reloadChannels() {
      if (this.entity.id_operator) {
        this.setLoadingMessage();
        this.channelService.channelList({id_operator: this.entity.id_operator})
            .then((data) => {
              this.channels = data['channels'];
              this.emptyMessage(true);
            })
      }
    }
  },
  watch: {
    'entity.id_operator': function (){
      this.reloadChannels();
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/thematicGroups/forms/ThematicGroupBasicForm.vue